import {createSelector} from 'reselect';
import {RootState} from '../../rootReducer';
import {getIsPushNotificationEnabled} from '../notifications';

export const getIsLoadingSettings = (state: RootState) => state.data.settings.isLoading;

export const getSettings = (state: RootState) => state.data.settings.settings;

export const getSupportLink = (state: RootState) => state.data.settings.supportLink;

export const getContactEmailAddress = (state: RootState) => state.data.settings.settings.contactEmailAddress;

export const getEulaLink = (state: RootState) => state.data.settings.eulaLink;

export const getPrivacyPolicy = (state: RootState) => state.data.settings.settings.effectivePrivacyPolicyUrl;

export const getMaxGroupWorkspaceInvitees = (state: RootState) =>
  state.data.settings.settings.maxNumberOfGroupWorkspaceInvitees;

export const getBookingRetentionPeriod = (state: RootState) => state.data.settings.settings.shiftsRetentionPeriodDays;

export const getAppLanguages = (state: RootState) => state.data.settings.appLanguages;

export const getAppLanguage = (state: RootState) => state.data.settings.appLanguage;

export const getIsChangingAppLanguage = (state: RootState) => state.data.settings.isChangingAppLanguage;

export const getWasDeskBookingOnboardingShown = (state: RootState) => state.data.settings.wasDeskBookingOnboardingShown;

export const getIsDeskBookingOnboardingLoaded = (state: RootState) => state.data.settings.isDeskBookingOnboardingLoaded;

export const getWasUserOnboardedToNotifications = createSelector(
  (state: RootState) => state.data.settings.wasUserOnboardedToNotifications,
  getIsPushNotificationEnabled,
  (wasUserOnboardedToNotifications, isPushNotificationEnabled) => {
    return isPushNotificationEnabled || wasUserOnboardedToNotifications;
  },
);

export const getStartOfTodayISOString = (state: RootState) => state.data.settings.startOfTodayISOString;

export const getHasUserClosedNotificationReminder = (state: RootState) =>
  state.data.settings.hasUserClosedPushNotificationReminder;

export const getIsUserClosedPushNotificationReminderLoaded = (state: RootState) =>
  state.data.settings.isUserClosedPushNotificationReminderLoaded;

export const getFaqLink = (state: RootState) => state.data.settings.faqLink;

export const getParkingSettings = (state: RootState) => state.data.settings.settings.parking;

export const getUserSettings = (state: RootState) => state.data.settings.userSettings;
export const getUserAccessControlSetttings = (state: RootState) =>
  state.data.settings.userSettings.settings.accessControl;
